(async()=> {
  if (!customElements.get('linked-products')) {
    class LinkedProducts extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {

        // Select first data-link, that is always the active one
        this.originalTitle = this.querySelector('[data-link]')?.title;

        // Target area to update
        this.heading = this.querySelector('[data-title]');
        // Select links and add events
        this.links = this.querySelectorAll('[data-link]');
        this.links.forEach(link => {
          link.addEventListener('mouseenter', (event) => {
            // Get title from attribute and set title
            const title = event.currentTarget?.title;
            if (title != '' && title != undefined) {
              this.heading.textContent = title;
            }
          });
          link.addEventListener('mouseleave', (event) => {
            this.heading.textContent = this.originalTitle;
          });
        });
      }
    }
    customElements.define('linked-products', LinkedProducts);
  }
})();